export class MatrixDeviceIdMismatchError extends Error {
    readonly code = 'MATRIX_DEVICE_ID_MISMATCH';

    constructor(
        readonly storedDeviceId: string,
        readonly receivedDeviceId: string,
    ) {
        super('The Matrix login used a different device ID than the preserved encryption store');
        this.name = 'MatrixDeviceIdMismatchError';
    }
}

export function getMatrixDeviceIdRecoveryCandidate(
    storedDeviceId: string | null,
    receivedDeviceId: string,
): string | null {
    return storedDeviceId && storedDeviceId !== receivedDeviceId
        ? storedDeviceId
        : null;
}
